import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Navbar from "./nav_bar/Navbar";
import HeroSection from "./hero_section/HeroSection";
import FeaturesSection from "./FeaturesSection";
import HowDoesItWork from "./HowDoesItWork";
import TimeTable from "./time_table/TimeTable";
import CookieBanner from "./CookieBanner";
import Footer from "./footer/Footer";
import TestimonialsSection from "./TestimonialsSection";
import AnnouncementBar from "../announcement/AnnouncementBar";
import WordOfDayBanner from "./home/WordOfDayBanner";
import FloatingWhatsAppButton from "./FloatingWhatsAppButton";
import MobileNumberPrompt from "./home/MobileNumberPrompt";
import WebImagesSection from "./home/WebImagesSection";
import CoursesSection from "./courses/CoursesSection";
import Faqs from "./faq/Faqs";

const Divider = () => (
  <div style={{ width: "100%", padding: "0 40px", boxSizing: "border-box" }}>
    <div style={{
      height: "2px",
      background: "linear-gradient(90deg, transparent, #00a8cc, #019095, #00a8cc, transparent)",
      borderRadius: "999px",
    }} />
  </div>
);

const Homepage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollToHowItWorks) {
      const section = document.getElementById("how-it-works");
      if (section) section.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  return (
    <>
      <Navbar />
      <AnnouncementBar />
      <MobileNumberPrompt />
      <HeroSection />
      <WordOfDayBanner />
      <WebImagesSection category="BANNER" />
      <Divider />
      <CoursesSection />
      <Divider />
      <TimeTable />
      <Divider />
      <FeaturesSection />
      <Divider />
      <TestimonialsSection />
      <Divider />
      <HowDoesItWork />
      <Divider />
      <Faqs />
      <CookieBanner />
      <Footer />
      <FloatingWhatsAppButton />
    </>
  );
};

export default Homepage;
